
import { useStore } from '@/store'
import { defineComponent, inject } from 'vue'
import { computed } from 'vue'
import CopyLinkButton from '@/components/Form/CopyLinkButton.vue'
import CheckoutButton from '@/components/Form/CheckoutButton.vue'
import Greenboard from '@/components/Form/Greenboard.vue'
import FormTab from '@/components/Abstract/FormTab.vue'
import bagsizeSettings from '@/settings/bagsize-settings.json'

export default defineComponent({
  name: 'GreenboardTab',
  components: {
    FormTab,
    CopyLinkButton,
    CheckoutButton,
    Greenboard
  },
  props: {
    index: Number,
    showButtons: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const store = useStore()
    const isAllConfigSet = computed(() => store.getters.isAllConfigSet)
    const configBagsizeId = computed(() => store.getters.configBagsizeId)
    const emitter: any = inject('emitter')

    const openGreenboard = () => {
      emitter.emit('openGreenboardDialog')
    }

    return {
      isAllConfigSet,
      openGreenboard,
      configBagsizeId,
      bagsizeSettings
    }
  }
})
